import React from "react";
import BreadCrumb from "../../../Common/BreadCrumb";

const ProgressbarPage = () => {
  return (
    <React.Fragment>
      <BreadCrumb title="Progress Bar" pageType="Elements" />
      <div className="flex flex-col gap-4 min-h-[calc(100vh-212px)]">
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          <div className="card">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Default Examples
            </h2>
            <div className="flex flex-col items-center justify-center gap-3">
              <div className="w-full h-4 rounded-full bg-light/80 dark:bg-white/10">
                <div className="w-3/12 h-4 rounded-full bg-purple"></div>
              </div>
              <div className="w-full h-4 rounded-full bg-light/80 dark:bg-white/10">
                <div className="w-4/12 h-4 rounded-full bg-purple"></div>
              </div>
              <div className="w-full h-4 rounded-full bg-light/80 dark:bg-white/10">
                <div className="w-5/12 h-4 rounded-full bg-purple"></div>
              </div>
              <div className="w-full h-4 rounded-full bg-light/80 dark:bg-white/10">
                <div className="w-6/12 h-4 rounded-full bg-purple"></div>
              </div>
              <div className="w-full h-4 rounded-full bg-light/80 dark:bg-white/10">
                <div className="w-7/12 h-4 rounded-full bg-purple"></div>
              </div>
              <div className="w-full h-4 rounded-full bg-light/80 dark:bg-white/10">
                <div className="w-8/12 h-4 rounded-full bg-purple"></div>
              </div>
            </div>
          </div>
          <div className="card">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Backgrounds
            </h2>
            <div className="flex flex-col items-center justify-center gap-3">
              <div className="w-full h-4 rounded-full bg-light/80 dark:bg-white/10">
                <div className="w-3/12 h-4 rounded-full bg-purple"></div>
              </div>
              <div className="w-full h-4 rounded-full bg-light/80 dark:bg-white/10">
                <div className="w-4/12 h-4 rounded-full bg-info"></div>
              </div>
              <div className="w-full h-4 rounded-full bg-light/80 dark:bg-white/10">
                <div className="w-5/12 h-4 rounded-full bg-success"></div>
              </div>
              <div className="w-full h-4 rounded-full bg-light/80 dark:bg-white/10">
                <div className="w-6/12 h-4 rounded-full bg-warning"></div>
              </div>
              <div className="w-full h-4 rounded-full bg-light/80 dark:bg-white/10">
                <div className="w-7/12 h-4 rounded-full bg-danger"></div>
              </div>
              <div className="w-full h-4 rounded-full bg-light/80 dark:bg-white/10">
                <div className="w-8/12 h-4 bg-black rounded-full"></div>
              </div>
            </div>
          </div>
          <div className="card">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Labels Example
            </h2>
            <div className="w-full h-3 rounded-full bg-light/80 dark:bg-white/10">
              <div className="flex items-center justify-center w-6/12 h-3 text-center rounded-full bg-black/80">
                <p className="text-[11px] text-white align-middle">50%</p>
              </div>
            </div>
          </div>
          <div className="card">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Labels Example
            </h2>
            <div className="flex w-full h-3 rounded-full bg-light/80 dark:bg-white/10">
              <div className="w-3/12 h-3 rounded-l bg-purple"></div>
              <div className="w-3/12 h-3 bg-success"></div>
              <div className="w-3/12 h-3 bg-black rounded-r"></div>
            </div>
          </div>
          <div className="card">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Sizes
            </h2>
            <div className="flex flex-col items-center justify-center gap-3">
              <div className="w-full">
                <h6 className="mb-1 text-sm text-black dark:text-white/80">
                  Progress sm
                </h6>
                <div className="w-full h-1 rounded-full bg-light/80 dark:bg-white/10">
                  <div className="w-3/12 h-1 rounded-full bg-purple"></div>
                </div>
              </div>
              <div className="w-full">
                <h6 className="mb-1 text-sm text-black dark:text-white/80">
                  Progress md
                </h6>
                <div className="w-full h-2 rounded-full bg-light/80 dark:bg-white/10">
                  <div className="w-4/12 h-2 rounded-full bg-success"></div>
                </div>
              </div>
              <div className="w-full">
                <h6 className="mb-1 text-sm text-black dark:text-white/80">
                  Progress lg
                </h6>
                <div className="w-full h-3 rounded-full bg-light/80 dark:bg-white/10">
                  <div className="w-5/12 h-3 bg-black rounded-full"></div>
                </div>
              </div>
              <div className="w-full">
                <h6 className="mb-1 text-sm text-black dark:text-white/80">
                  Progress xl
                </h6>
                <div className="w-full h-4 rounded-full bg-light/80 dark:bg-white/10">
                  <div className="w-6/12 h-4 rounded-full bg-danger"></div>
                </div>
              </div>
            </div>
          </div>
          <div className="card">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Striped
            </h2>
            <div className="flex flex-col items-center justify-center gap-3">
              <div className="w-full h-4 rounded-full bg-black/10 dark:bg-white/10">
                <div
                  className="w-3/12 h-4 rounded-full bg-purple"
                style={{backgroundImage: "linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)", backgroundSize: "1rem 1rem" }}
                ></div>
              </div>
              <div className="w-full h-4 rounded-full bg-black/10 dark:bg-white/10">
                <div
                  className="w-4/12 h-4 rounded-full bg-info"
                  style={{backgroundImage: "linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)", backgroundSize: "1rem 1rem"}}
                ></div>
              </div>
              <div className="w-full h-4 rounded-full bg-black/10 dark:bg-white/10">
                <div
                  className="w-5/12 h-4 rounded-full bg-success"
                  style={{backgroundImage: "linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)", backgroundSize: "1rem 1rem"}}
                ></div>
              </div>
              <div className="w-full h-4 rounded-full bg-black/10 dark:bg-white/10">
                <div
                  className="w-6/12 h-4 bg-black rounded-full"
                  style={{backgroundImage: "linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)", backgroundSize: "1rem 1rem"}}
                ></div>
              </div>
              <div className="w-full h-4 rounded-full bg-black/10 dark:bg-white/10">
                <div
                  className="w-7/12 h-4 rounded-full bg-danger"
                  style={{backgroundImage: "linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)", backgroundSize: "1rem 1rem"}}
                ></div>
              </div>
              <div className="w-full h-4 rounded-full bg-black/10 dark:bg-white/10">
                <div
                  className="w-8/12 h-4 rounded-full bg-warning"
                  style={{backgroundImage: "linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)", backgroundSize: "1rem 1rem"}}
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ProgressbarPage;
